'use strict';

var React = require('react');

var SvgRepeatOrderMajor = function SvgRepeatOrderMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 8a.992.992 0 0 1 .294-.707l2.999-3a1 1 0 1 1 1.414 1.414l-1.293 1.293h6.086a2.5 2.5 0 0 0 0-5 1 1 0 1 1 0-2c2.481 0 4.5 2.018 4.5 4.5 0 2.481-2.019 4.5-4.5 4.5h-6.086l1.293 1.293a.999.999 0 0 1-.707 1.709.997.997 0 0 1-.706-.294l-3-3a.99.99 0 0 1-.217-.326.992.992 0 0 1-.077-.382zm-3-5v11h3.5c.775 0 1.388.662 1.926 1.244l.11.12a2 2 0 0 0 2.927-.001l.11-.119h.001c.538-.582 1.151-1.244 1.926-1.244h3.5v-2a1 1 0 1 1 2 0v5.5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-15a1.5 1.5 0 0 1 1.5-1.5h4.5a1 1 0 0 1 0 2h-4z"
  }));
};

exports.SvgRepeatOrderMajor = SvgRepeatOrderMajor;
